import { api } from "../api";
import { backendErrors } from "@/forms/service/common";
import { Subscribe } from "@/api/forms";

export const SUBSCRIPTION_FORM_STEPS = {
  FIRST_STEP: "FIRST_STEP",
  THANK_YOU_STEP: "THANK_YOU_STEP"
};

export const subscriptionSubmit = async (data: Subscribe) => {
  const { data: responseData } = await api.forms.subscriptionSalesManago(data);

  if (responseData.errors) {
    throw { errors: backendErrors(responseData.errors || {}) };
  }
  return {
    data: responseData,
    next: SUBSCRIPTION_FORM_STEPS.THANK_YOU_STEP
  };
};
